/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';

import styles from '../../../../ActionDrawer.module.scss';

/*
type TypeProps = {
    formData: Object
} & TranslatorProps;
*/

@translate()
@inject('actionDrawerStore', 'costCenterDetailsStore')
@observer
export default class UnarchiveCostCenterSuccess extends React.Component<*> {
  componentDidMount() {
    this.props.costCenterDetailsStore.details.status = true;
    this.props.costCenterDetailsStore.details.archived_at = null; // eslint-disable-line camelcase
  }

  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const response: Object = this.props.response;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:cost_centers.unarchived')}
          >
            <p>{t('general:cost_centers.messages.unarchived')}</p>
            <React.Fragment>
              {response && (
                <div className={styles['success-details']}>
                  {response.code && response.name && (
                    <ul>
                      <li>
                        <b>{t('general:cost_center')}: </b>
                      </li>
                      <li>{`${response.code} - ${response.name}`}</li>
                    </ul>
                  )}
                </div>
              )}
            </React.Fragment>
          </ActionDrawerBlock>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
